<template>
    <el-dialog class="dialog" :visible="dialogs.kinds.visible" customClass="dialog_main" :append-to-body="true" :close-on-click-modal="false" @close="closeDialog()" @open="loadItems">
        <div slot="title" class="dialog__head dialog__head_second">
            <div class="dialog__head-inner">
                <h3 class="dialog__title">Создать или найти ВПД</h3>
            </div>
        </div>

        <div class="dialog__inner">
            <local-preloader v-if="kindsLoader" />

            <div v-else class="dialog__content">
                <form class="search-form" @submit.prevent>
                    <div class="search-form__inner">
                        <input type="search" class="input search-form__input" :class="{ 'search-form__input_reset': input && input.length !== 0 }" placeholder="Поиск" v-model.trim="input" @keydown.enter.prevent.stop>

                        <button v-if="input && input.length !== 0" class="search-form__reset" @click="input = ''">
                            <icon-base viewBox="0 0 14 14"><icon-cancel /></icon-base>
                        </button>

                        <button class="search-form__submit" disabled>
                            <icon-base viewBox="0 0 24 24"><icon-search /></icon-base>
                        </button>
                    </div>
                </form>

                <transition name="fade">
                    <div class="dialog__section" v-if="this.groupItemsBy.name === 'area_id' && createEntity">
                        <h3>Заполните новый ВПД</h3>

                        <form class="entity-form" @submit.prevent="createItem">
                            <div class="entity-form__inner">
                                <div class="entity-form__item">
                                    <el-checkbox v-model="checkedEntity" />
                                </div>
                                <div class="entity-form__item entity-form__item_code">
                                    <div class="input__inner">
                                        <masked-input 
                                            name="code"
                                            class="input"
                                            :class="{'input_error': codeError}"
                                            v-model="code"
                                            placeholder="Код"
                                            :mask="{
                                                pattern: `\\${ String(dialogs.kinds.data.areaCode).padStart(2, 0) }.111`
                                            }"
                                        />
                                    </div>
                                </div>
                                <div class="entity-form__item entity-form__item_name">
                                    <validate-input v-model="name" v-bind:error="nameError" v-on:update:error="nameError = $event" type="text" name="name" placeholder="Название" :validateOptions="['empty']" />
                                </div>
                                <div class="entity-form__item">
                                    <validate-input v-model="purpose" v-bind:error="purposeError" v-on:update:error="purposeError = $event" type="text" name="purpose" placeholder="Основная цель ВПД" :validateOptions="['empty']" />
                                </div>
                                <div class="entity-form__item entity-form__item_select">
                                    <v-select class="select" placeholder="Жизненный цикл" label="name" v-model="entityLifecycleId" :clearable="false" :options="lifecycles" :reduce="(item) => item.id">
                                        <template #search="{attributes, events}">
                                            <input
                                                class="vs__search"
                                                :required="!entityLifecycleId"
                                                v-bind="attributes"
                                                v-on="events"
                                            />
                                        </template>
                                        <template #no-options="{ search, searching, loading }">
                                            {{ SELECT_NOT_FOUND }}
                                        </template>
                                        <template #open-indicator="{ attributes }">
                                            <span v-bind="attributes">
                                                <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                            </span>
                                        </template>
                                    </v-select>
                                </div>
                                <div class="entity-form__item">
                                    <button type="submit" :disabled="!code || codeError || !name || !purpose || !entityLifecycleId" class="btn btn_action">Создать</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </transition>

                <el-table
                    cell-class-name="table__cell"
                    class="table table_second"
                    header-cell-class-name="table__title"
                    :max-height="createEntity ? 250 : 300"
                    ref="table"
                    row-key="id"
                    :data="filteredData"
                    @sort-change="sortChange"
                >
                    <el-table-column
                            width="24"
                    >
                        <template slot-scope="scope">
                            <div class="table_flex">
                                <el-checkbox @change="handleSelectionChange([scope.row])"/>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Код"
                        prop="code"
                        sortable="custom"
                        :min-width="10"
                        :sort-orders="['ascending', 'descending']"
                    >
                    </el-table-column>
                    <el-table-column
                        label="Название"
                        prop="name"
                        sortable="custom"
                        :min-width="90"
                        :sort-orders="['ascending', 'descending']"
                    >
                    </el-table-column>
                </el-table>

                <h3 class="dialog__title mt-32 mb-16">Выбранные сущности</h3>

                <el-table
                    cell-class-name="table__cell"
                    class="table table_second"
                    header-cell-class-name="table__title"
                    :max-height="createEntity ? 250 : 300"
                    row-key="id"
                    :show-header="false"
                    :data="selection"
                    :default-sort="{ prop: 'code', order: 'ascending' }"
                >
                    <el-table-column
                        width="24"
                    >
                        <template slot-scope="scope">
                            <div class="table_flex">
                                <el-checkbox checked @change="deleteSelectionChange([scope.row])"/>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Код"
                        prop="code"
                        sortable="custom"
                        :min-width="10"
                        :sort-orders="['ascending', 'descending']"
                    >
                    </el-table-column>
                    <el-table-column
                        label="Название"
                        prop="name"
                        sortable="custom"
                        :min-width="90"
                        :sort-orders="['ascending', 'descending']"
                    >
                    </el-table-column>
                </el-table>

                <el-pagination
                    background
                    class="mt-24"
                    layout="prev, pager, next"
                    :current-page="page"
                    :hide-on-single-page="true"
                    :page-size="pageSize"
                    :total="total"
                    @current-change="setPage"
                >
                </el-pagination>
            </div>

            <footer slot="footer" class="dialog__footer mt-24">
                <div class="dialog__footer-inner">
                    <div class="dialog__footer-item">
                        <button type="button" class="btn" @click="closeDialog">Отменить</button>
                    </div>
                    <div class="dialog__footer-item">
                        <button type="submit" class="btn btn_action-second" v-if="this.groupItemsBy.name === 'area_id'" :disabled="createEntity || kindsLoader" @click="createEntity = true">
                            Создать новый ВПД

                            <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon"><icon-action /></icon-base>
                        </button>
                        <button type="submit" class="btn btn_action" :disabled="kindsLoader || selection.length === 0" @click="addItems">Добавить выбранные ВПД</button>
                    </div>
                </div>
            </footer>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import MaskedInput from 'vue-masked-input';
import LocalPreloader from '@/components/LocalPreloader'

import constants from '@/constants.js';

import dialog from '@/mixins/dialog';
import ValidateInput from '@/components/ValidateInput'

export default {
    mixins: [ dialog ],
    components: {
        MaskedInput,
        LocalPreloader,
        ValidateInput
    },
    props: {
        kindsLoader: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            checkedEntity: true,
            entityLifecycleId: null,
            code: '',
            name: '',
            purpose: '',
            codeError: false,
            nameError: false,
            purposeError: false,
        }
    },
    methods: {
        ...mapActions('editor', [
            'LOAD_ALL_KINDS',
            'SAVE_KINDS'
        ]),
        ...mapActions('listsForEditor', [
            'CREATE_KIND',
        ]),
        ...mapMutations('editor', ['GROUP_KINDS', 'SET_SELECTED_AREAS']),

        closeDialog() {
            this.code = ''
            this.name = ''
            this.purpose = ''
            this.createEntity = false
            this.codeError = false
            this.nameError = false
            this.purposeError = false

            this.selection = []

            this.elDialogs.kinds = {
                visible: false,
                data: {}
            };
        },
        handleSelectionChange(val) {
            this.selection = [...val, ...this.selection];
        },
        deleteSelectionChange(val) {
            this.selection = this.selection.filter(select => !val.find(item => item.id === select.id))
        },
        loadItems() {
            this.data = this.allKindsList
        },

        async addItems() {
            const params = {
                area_id: this.elDialogs.kinds.data.groupId,
                kinds: this.selection.map((item) => item.id)
            }
            await this.SAVE_KINDS(params);
        
            this.closeDialog();
        },
        createItem(e) {
            // Собираем новые значения и отправляем
            const formData = new FormData(e.target);
            const { groupId } = this.dialogs.kinds.data;

            const params = {
                area_id: groupId, // Код ОПД
                lifecycle_id: this.entityLifecycleId // Код жизненного цикла
            };

            for (const pair of formData.entries()) {
                params[pair[0]] = pair[1];
            }

            this.CREATE_KIND(params).then((kind) => {
                e.target.reset();

                this.entityLifecycleId = null;

                this.data = [...this.allKindsList];

                if (this.checkedEntity) {
                    this.selection.push(kind);
                }
            });
        },
        sortChange(v) {
            if (v.column.order === 'ascending') {
                this.data.sort(this.sortListAsc(v.column.property));
            } else if (v.column.order === 'descending') {
                this.data.sort(this.sortListDesc(v.column.property));
            }
        }
    },
    computed: {
        ...mapState('editor', ['groupKinds', 'groupItemsBy', 'kinds', 'lifecycles']),
        ...mapState('listsForEditor', ['allKindsList']),

        filtered() {
            // Фильтруем по поиску
            return !this.searchValue ? this.data : this.data.filter((item) => String(item.code).toLowerCase().includes(this.searchValue.toLowerCase()) || item.name.toLowerCase().includes(this.searchValue.toLowerCase()));
        },
        tableData() {
            // Пагинация
            return this.filtered.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
        },
        filteredData() {
            return this.tableData.filter(el => !this.selection.find(select => select.id === el.id))
        }
    },
    watch: {
        kindsLoader: function(val) {
            if (!val) this.loadItems()
        },
        code: function(val) {
            if (!val) this.codeError = true
            else if (val.includes('_')) this.codeError = true
            else this.codeError = false
        }
    },
    created() {
        this.SELECT_NOT_FOUND = constants.SELECT_NOT_FOUND;
    }
}
</script>
